import * as React from 'react';

import {
  DataCatalogCopy,
  DataCatalogSchema,
  DataCatalogTestIds,
} from 'bones/components/molecules/DataCatalog/types/schema';
import { noop } from 'bones/utils/noop';
import { processTestIds } from 'bones/utils/processTestIds';
import { DataCatalogResultType } from 'bones/utils/store/dataCatalog/types';

const defaultCopy: DataCatalogCopy = {
  searchInput: {
    placeholder: 'Search',
  },
  searchInputMenu: {
    noResults: 'No results',
    seeAll: 'see all results',
  },
  searchResults: {
    cardDetail: (label, value) => `${label}: ${value}`,
    count: (query, count) =>
      `Showing ${count} result${count === 1 ? '' : 's'} for '${query}'`,
    tabs: (label, count) => `${label} (${count})`,
  },
  typeLabels: {
    singular: {
      [DataCatalogResultType.ALL]: 'All',
      [DataCatalogResultType.DATA_SOURCE]: 'Data Source',
      [DataCatalogResultType.CATALOG]: 'Catalog',
      [DataCatalogResultType.SCHEMA]: 'Schema',
      [DataCatalogResultType.TABLE]: 'Table',
      [DataCatalogResultType.COLUMN]: 'Column',
    },
    plural: {
      [DataCatalogResultType.ALL]: 'All',
      [DataCatalogResultType.DATA_SOURCE]: 'Data Sources',
      [DataCatalogResultType.CATALOG]: 'Catalogs',
      [DataCatalogResultType.SCHEMA]: 'Schemas',
      [DataCatalogResultType.TABLE]: 'Tables',
      [DataCatalogResultType.COLUMN]: 'Columns',
    },
  },
};

const defaultStringTestIds: Omit<
  DataCatalogTestIds,
  'searchInputMenuItem' | 'searchResultCard' | 'searchResultsTab'
> = {
  searchInputClear: '',
  searchInputInput: '',
  searchInputMenu: '',
  searchInputMenuSeeAll: '',
};
processTestIds(defaultStringTestIds, '-', 'sd-data-catalog');

const defaultTestIds: DataCatalogTestIds = {
  ...defaultStringTestIds,
  searchInputMenuItem: (id: string) =>
    `sd-data-catalog-search-input-menu-item-${id}`,
  searchResultCard: (id: string) => `sd-data-catalog-search-result-card-${id}`,
  searchResultsTab: (tabId: string) =>
    `sd-data-catalog-search-results-tab-${tabId}`,
};

export const DEFAULT_DATA_CATALOG_SCHEMA: DataCatalogSchema = {
  copy: defaultCopy,
  testIds: defaultTestIds,

  databaseId: 'catalog',

  searchInput: {
    menuLimit: 6,
    onClickResult: noop,
    onClickSeeAll: noop,
  },
  searchResults: {},
};

export const DataCatalogSchemaContext = React.createContext<DataCatalogSchema>(
  DEFAULT_DATA_CATALOG_SCHEMA
);

export const useDataCatalogSchema = () => {
  const schema = React.useContext(DataCatalogSchemaContext);
  return schema;
};
